import React from 'react';
function ShoppingBag({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.667 3L4 6.6v12.6c0 .477.187.935.52 1.273.334.337.786.527 1.258.527h12.444c.472 0 .924-.19 1.257-.527.334-.338.521-.796.521-1.273V6.6L17.333 3H6.667zM4 7h16M16 10a4 4 0 11-8 0"
      />
    </svg>
  );
}

export default ShoppingBag;
